export enum UserGradeEnum {
  advance = 3,
  medium = 2,
  beginner = 1,
}
